// DataUpload.js
/** CSVデータ（カラム名）⇔ jsonデータ（属性名）のマッピング設定 */
export const ATTRIBUTE_MAPPING = {
  法人番号: 'corporation_number',
  企業名: 'corporationName',
  年度: 'year',
  決算年月: 'fiscal_year_month',
  入社年月日: 'hire_date',
  退職年月日: 'retirement_date',
  休職者判定: 'leave_judgement',
  休職回数: 'leave_times',
  集計先: 'aggregation_destination'
}

/**
 * データをAPI送信形式に変換する関数
 *
 * @param {DataItem[]} dataList - データリスト
 * @param {Object} mapping - 属性名のマッピングオブジェクト
 * @returns {Object[]} 変換後のデータリスト
 */
export const convertToFileData = (dataList, mapping, conditions) => {
  return dataList.map((item) => {
    const convertedItem = {}
    Object.keys(item).forEach((csvKey) => {
      const newKey = mapping[csvKey]
      let value = item[csvKey]
      if (csvKey === '休職者判定') {
        if (!conditions.leaveCount) {
          value = ''
        } else {
          switch (conditions.leaveCountType) {
            case 'times':
              value = '1'
              break
            case 'endPoint':
              value = '2'
              break
            default:
              value = ''
          }
        }
        value = value !== undefined && value !== null ? String(value) : ''
      } else if (csvKey === '休職回数') {
        if (conditions.leaveCount && conditions.leaveCountType === 'times') {
          value = conditions.leaveCountTimes || ''
        } else {
          value = ''
        }
        value = value !== undefined && value !== null ? String(value) : ''
      } else if (csvKey === '入社年月日') {
        value = conditions.joinDate ? value : null
      } else if (csvKey === '退職年月日') {
        value = conditions.retireDate ? value : null
      }
      convertedItem[newKey] = value
    })
    return convertedItem
  })
}
